import React from 'react';
import { COPY_SPECIFIC, URLS } from '@sonar-software/sonar-ts-constants';

export const PrivacyPolicyLink: React.FC = () =>
	<a
		href={ URLS.PRIVACY_POLICY }
		rel='noopener'
		target='_blank'>
		{ COPY_SPECIFIC.PRIVACY_POLICY }
	</a>;
